import React, { useState, useEffect, useRef } from 'react';

const ProtectedImage = ({ src, alt, className }) => {
  const canvasRef = useRef(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !src) return;

    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = function() {
      try {
        // Set canvas size
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        
        // Draw image
        ctx.drawImage(img, 0, 0);
        
        // Add watermark
        ctx.globalAlpha = 0.05;
        ctx.font = 'bold 48px Arial';
        ctx.fillStyle = '#000000';
        ctx.textAlign = 'center';
        
        // Draw watermark grid
        for (let y = 60; y < canvas.height; y += 150) {
          for (let x = 120; x < canvas.width; x += 250) {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(-25 * Math.PI / 180);
            ctx.fillText('AFTRUSTCA', 0, 0);
            ctx.restore();
          }
        }
        
        setImageLoaded(true);
        setImageError(false);
      } catch (error) {
        console.error('Canvas error:', error);
        setImageError(true);
      }
    };
    
    img.onerror = function(error) {
      console.error('Image load error:', error);
      setImageError(true);
    };
    
    // Load image
    img.src = src;
    
  }, [src]);

  const preventActions = (e) => {
    e.preventDefault();
    return false;
  };

  if (imageError) {
    return (
      <div className={`${className} bg-gray-200 flex items-center justify-center`}>
        <span className="text-gray-500 text-sm">Image error</span>
      </div>
    );
  }

  return (
    <div className="relative w-full h-full">
      {!imageLoaded && (
        <div className={`${className} bg-gray-100 animate-pulse flex items-center justify-center`}>
          <span className="text-gray-400 text-sm">Loading...</span>
        </div>
      )}
      
      <canvas
        ref={canvasRef}
        className={`${className} ${imageLoaded ? '' : 'hidden'}`}
        onContextMenu={preventActions}
        onDragStart={preventActions}
        style={{ 
          userSelect: 'none',
          WebkitUserSelect: 'none',
          width: '100%',
          height: '100%'
        }}
      />
      
      <div 
        className="absolute inset-0"
        onContextMenu={preventActions}
        onDragStart={preventActions}
      />
    </div>
  );
};

export default ProtectedImage;
